import { orchestrator } from 'satcheljs';
import { setColor } from '../actions';
import getAsset from '../selectors/getAsset';
import patchAsset from '../utils/patchAsset';

orchestrator(setColor, ({ projectId, assetId, color }) => {
    patchAsset(
        projectId,
        assetId,
        { color },
        { color: getAsset(projectId, assetId).color },
        asset => asset.color == color
    );
});
